const firebaseConfig = {
    apiKey: "AIzaSyBq2o6ZsdTlliUFfbFnYPz7LuiSbBEa_jw",
    authDomain: "hospital-ae70e.firebaseapp.com",
    projectId: "hospital-ae70e",
    storageBucket: "hospital-ae70e.appspot.com",
    messagingSenderId: "346332008494",
    appId: "1:346332008494:web:84cf075ec3c56370200fbf"
};

export default firebaseConfig;